var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissionkit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "MissionKit",
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.3 28.8c0 15.7-12.8 28.5-28.5 28.5S.3 44.5.3 28.8 13.1.3 28.8.3s28.5 12.8 28.5 28.5z",
    fill: "#323638"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2 8.1a6.4 6.4 0 0 0-8.9 0L28.8 19.5h-.1l-5.9-5.9c-1.2-1.2-2.7-1.9-4.5-1.9-3.5 0-6.4 2.8-6.4 6.3v21.4c0 1.6.6 3.2 1.9 4.5 2.5 2.5 6.5 2.5 9 0l3.3-3.2c.7-.7 1.6-1.2 2.7-1.2h.1c1.1 0 2 .4 2.7 1.2l3.3 3.2c2.5 2.5 6.5 2.5 9 0 1.2-1.2 1.9-2.9 1.9-4.5V20.6l3.6-3.7c2.3-2.4 2.2-6.4-.2-8.8z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2 12.8c0 2.1-1.7 3.9-3.9 3.9-2.1 0-3.9-1.7-3.9-3.9 0-2.1 1.7-3.9 3.9-3.9s3.9 1.7 3.9 3.9zm-12.1 4.6c1.4-1.4 3.6-1.4 5 0s1.4 3.6 0 5L33 30.6c-1.4 1.4-3.6 1.4-5 0s-1.4-3.6 0-5l8.1-8.2z",
    fill: "#c03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionkit);
export default __webpack_public_path__ + "static/media/missionkit.de3d5292a20297521d5af00a6b9f7270.svg";
export { ForwardRef as ReactComponent };